import { render, staticRenderFns } from "./partListPage.vue?vue&type=template&id=48a8342f&scoped=true&"
import script from "./partListPage.vue?vue&type=script&lang=js&"
export * from "./partListPage.vue?vue&type=script&lang=js&"
import style0 from "./partListPage.vue?vue&type=style&index=0&id=48a8342f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a8342f",
  null
  
)

export default component.exports